import React from 'react';
import WaterMeterInstallationPage from '../../water-meter-installation-page';

import wiringDiagram from '../../../../assets/product-interaction/joys550/joys550_wiring.jpg';

const LXSYInstallation = () => (
  <WaterMeterInstallationPage
    model="LXSY"
    backUrl="/product/lxsy"
    wiringDiagram={wiringDiagram}
    wiringAlt="LXSY 水表通过 M-Bus 接入 GW214 采集器接线图"
  />
);

export default LXSYInstallation;
